module.exports = __webpack_public_path__ + "static/915675116.192b0529.jpg";